import React from 'react'
import styled from 'styled-components'
import { media } from 'utils/media'
import { Link } from 'lib/Link'
import { Text } from 'lib/Text'
import { textSize, textWeight } from 'lib/Text'
import { useCategories } from 'modules/categories/queries/useCategories'

const Categories = styled.ul`
  columns: 4;
  text-align: left;
  ${media.desktopBoundsDown} {
    columns: 4 200px;
  }
  ${media.tabletDown} {
    columns: 3 200px;
  }
  ${media.phoneDown} {
    columns: 1;
  }
}
`

const Category = styled.li`
  break-inside: avoid-column;
  margin-bottom: 20px;
  page-break-inside: avoid;
`

const SubCategories = styled.ul`
  ${textWeight('regular')}
  ${textSize('pxs')}
`

const SubCategory = styled.li`
  padding-left: 14px;
  ${media.phoneDown} {
    padding-left: 0;
  }
`

export const CategoryTable = () => {
  const { data } = useCategories()

  if (!data) {
    return null
  }

  const rootCategories = data.categories.filter((category) => !category.parent)

  return (
    <Categories>
      {rootCategories.map((category) => (
        <Category key={category.id}>
          <Link
            underlineOnNormalState={false}
            href={{
              pathname: '/categories/[slug]',
              query: { slug: category.slug }
            }}>
            <Text as="span" weight="semi" size="pxs" color="black-100">
              {category.name}
            </Text>
          </Link>
          {category.children && category.children.length > 0 && (
            <SubCategories>
              {category.children.map((subCategory) => (
                <SubCategory key={subCategory.id}>
                  <Link
                    underlineOnNormalState={false}
                    href={{
                      pathname: '/categories/[slug]',
                      query: { slug: subCategory.slug }
                    }}>
                    {subCategory.name}
                  </Link>
                </SubCategory>
              ))}
            </SubCategories>
          )}
        </Category>
      ))}
    </Categories>
  )
}
